// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1QvCc","right":"Footer_right__7n2l_","buttons":"Footer_buttons__2ykt8"};